<template>
  <v-card color="primary" class="elevation-0 text-left border-0">
    <v-card-title class="px-4 py-4">
      
        <v-flex xs12 sm12 md6 lg6>
          <h2 v-if="title" :class="customTitleStyle" v-text="title"></h2>
          <p v-if="subtitle" class="white--text subtitle-2 mb-0" v-text="subtitle"></p>
        </v-flex>
        <v-flex xs12 md6 lg6  class="text-md-right text-xs-left">
          <slot name="action"></slot>
        </v-flex>      
    
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  props: ['title', 'subtitle'],
  computed: {
    customTitleStyle: function() {
      if(this.subtitle){
        return 'headline font-weight-regular primary text-uppercase white--text';
      } else {
        return 'headline font-weight-regular primary text-uppercase white--text';
      }
    },
  }
}
</script>